import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import get from 'immutable-less/transmute/get';
import getIn from 'immutable-less/transmute/getIn';
import ObjectTypeKeys from 'automation-ui-references/object-types/ObjectTypeKeys';
import * as InboundDbMetaTypeIds from 'automation-ui-references/object-types/InboundDbMetaTypeIds';
/**
 * Allowlist of object type `metaTypeId`s allowed in Workflows
 */
export const WORKFLOWS_ALLOWED_CUSTOM_OBJECT_META_TYPE_IDS = [InboundDbMetaTypeIds.PORTAL_SPECIFIC, InboundDbMetaTypeIds.CMS_HUBDB];
export const getId = get(ObjectTypeKeys.ID);
export const getMetaId = get(ObjectTypeKeys.META_TYPE_ID);
export const getName = get(ObjectTypeKeys.NAME);
export const getSingularForm = get(ObjectTypeKeys.SINGULAR_FORM);
export const getPluralForm = get(ObjectTypeKeys.PLURAL_FORM);
export const getPrimaryDisplayLabel = get(ObjectTypeKeys.PRIMARY_DISPLAY_LABEL);
export const getDefaultSearchPropertyNames = get(ObjectTypeKeys.DEFAULT_SEARCH_PROPERTY_NAMES);
export const getSecondaryDisplayLabels = get(ObjectTypeKeys.SECONDARY_DISPLAY_LABELS);
export const getRequiredProperties = get(ObjectTypeKeys.REQUIRED_PROPERTIES);
export const getFullyQualifiedName = get(ObjectTypeKeys.FULLY_QUALIFIED_NAME);
export const getObjectTypeId = objectTypeDefinition => {
  const metaId = getMetaId(objectTypeDefinition);
  const id = getId(objectTypeDefinition);
  return `${metaId}-${id}`;
};
export const getMetaTypeIdFromObjectTypeId = objectTypeId => Number(objectTypeId.split('-')[0]);
export const getMetaTypeStringFromObjectTypeId = objectTypeId => objectTypeId.split('-')[0];
export const getTypeIdFromObjectTypeId = objectTypeId => Number(objectTypeId.split('-')[1]);
export const isHubSpotDefinedObject = objectTypeId => {
  const metaId = getMetaTypeIdFromObjectTypeId(objectTypeId);
  return metaId === InboundDbMetaTypeIds.HUBSPOT;
};
export const isCustomObject = objectTypeId => !isHubSpotDefinedObject(objectTypeId);
export const getAllPortalSpecificObjectDefinitions = objectTypeDefinitions => {
  return objectTypeDefinitions.filter(definition => definition.metaTypeId ? WORKFLOWS_ALLOWED_CUSTOM_OBJECT_META_TYPE_IDS.includes(definition.metaTypeId) : false);
};
export const getLabelByPrimaryDisplayLabel = objectTypeDefinition => {
  return getIn(['properties', getPrimaryDisplayLabel(objectTypeDefinition), 'value']);
};

/**
 * Note that the translation only works in PROD. There is
 * an open git issue with Linguini to bring them down to QA
 * but for now, don't rely on QA to properly translate
 * HubSpot defined object type names.
 * https://git.hubteam.com/HubSpot/Linguine/issues/221
 *
 * @return always returns a string. It will be an empty
 * string if no object type definition is defined.
 */
export const getObjectTypeName = ({
  isCapitalized,
  isPlural,
  objectTypeDefinition
}) => {
  if (!objectTypeDefinition) {
    return '';
  }
  let name = isPlural ? getPluralForm(objectTypeDefinition) : getSingularForm(objectTypeDefinition);
  name = name || getName(objectTypeDefinition) || 'UNKNOWN';
  if (!isCapitalized) {
    return name.toLocaleLowerCase(getLang());
  }
  return name;
};
export const getFeedbackSubmissionTimestamp = object => {
  return I18n.moment
  // "Invalid date" string being rendered
  // https://product.hubteam.com/docs/frontend/docs/i18n/dates.html#time-zones
  .userTz(Number(object.properties.hs_submission_timestamp.value)).format('lll');
};